import { Box, Button, Grid, Skeleton, Theme, Typography } from "@mui/material";
import { PieChartComponentLoading } from "../directEquity/LoadingComponents";
import CustomTable from "../common/customTable";


interface IndNavBtnProps {
    type: string,
    count?: number,
    text: string
}

const navChartButtons = [{
    type: 'month',
    count: 6,
    text: '6M'
}, {
    type: 'year',
    count: 1,
    text: '1Y'
},
{
    type: 'all',
    text: 'Inception'
}]

const CreditRatingLoader = () => {
    return (
        <Box sx={(theme: Theme) => ({
            padding: '25px 30px 45px 30px',
            background: theme.palette.common.white,
            borderRadius: '20px',
            height: '100%',
            width: '100%'
        })}>
            <PieChartComponentLoading title="Credit Rating Allocation" />
        </Box>
    )
}


export const BondsPerformanceLoader = (): JSX.Element => {
    return (
        <>
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                rowGap: '10px',
                mb: '55px'
            }}>
                <Typography
                    variant="h2"
                    color='text.primary'
                >
                    Performance
                </Typography>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: { sm: 'flex-end', md: 'flex-start' },
                    columnGap: 3,
                }}>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            columnGap: '7px'
                        }}>
                        <Skeleton
                            variant="circular"
                            width={11}
                            height={11}
                            animation="wave"
                        />
                        <Skeleton
                            animation="wave"
                            sx={{ fontSize: '16px' }}
                            width="5rem"
                        />
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            columnGap: '7px'
                        }}
                    >
                        <Skeleton
                            variant="circular"
                            width={11}
                            height={11}
                            animation="wave"
                        />
                        <Skeleton
                            animation="wave"
                            sx={{ fontSize: '16px' }}
                            width="5rem"
                        />
                    </Box>
                </Box>
            </Box>
            <Box>
                <Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Skeleton variant="rectangular" width={10} height={130} />
                        <Skeleton variant="rectangular" width={10} height={130} />
                        <Skeleton variant="rectangular" width={10} height={130} />
                    </Box>
                    <Box sx={{ display: 'flex' }}>
                        <Skeleton variant="rectangular" width='100%' height={10} />
                    </Box>
                </Box>

                <Box
                    sx={{
                        mt: '45px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        columnGap: '10px'
                    }}
                >
                    {navChartButtons?.map((individualBtn: IndNavBtnProps, index: number) => {
                        return (
                            <Button sx={(theme: Theme) => (
                                {
                                    ...theme.typography.body_500, letterSpacing: '0.02px', borderRadius: '7px', padding: '5px 15px', border: 'none', cursor: 'pointer', color: "Inception" === individualBtn?.text ? theme.palette.common.white : theme.palette.text.secondary, '&:hover': {
                                        border: 'none',
                                    }
                                }
                            )} variant={"Inception" === individualBtn?.text ? 'contained' : 'outlined'} key={index}
                                disabled={true}
                            >{individualBtn?.text}</Button>
                        )
                    })}
                </Box>
            </Box>
        </>
    )
}

export const Top10BondHoldingsLoader = (): JSX.Element => {
    return (
        <>
            <Typography
                variant="h2"
                sx={(theme: Theme) => ({
                    lineHeight: "25px",
                    letterSpacing: "0.01px",
                    color: theme.palette.text.primary
                })}
            >
                Top 10 Debt-Holdings
            </Typography>
            <Box sx={{ marginTop: "20px" }}>
                <CustomTable
                    isLoading={true}
                    tableHeaderData={[...Array(6)]}
                    tableBodyLoaderRowCustomStyles={{
                        '& td:first-of-type': {
                            paddingLeft: "0px"
                        },
                    }}
                    tableHeadRowCustomStyles={{
                        '& th:first-of-type': {
                            paddingLeft: "0px"
                        }
                    }}
                    loadingRowsNum={5}
                />
            </Box>
        </>
    )
}

export const BondsQuantativeAnalysisLoader = (): JSX.Element => {
    return (
        <>
            <Typography
                variant="h2"
                sx={(theme: Theme) => ({
                    lineHeight: "25px",
                    letterSpacing: "0.01px",
                    color: theme.palette.text.primary
                })}
            >
                Quantative Analysis
            </Typography>
            <Box sx={{ marginTop: "20px" }}>
                <CustomTable
                    isLoading={true}
                    tableHeaderData={[...Array(2)]}
                    tableBodyLoaderRowCustomStyles={{
                        '& td:first-of-type': {
                            paddingLeft: "0px"
                        },
                    }}
                    tableHeadRowCustomStyles={{
                        '& th:first-of-type': {
                            paddingLeft: "0px"
                        }
                    }}
                    loadingRowsNum={5}
                />
            </Box>
        </>
    )
}

export default function BondsOverViewLoading(): JSX.Element {
    return (
        <Box>
            <Grid container spacing={2}>
                <Grid item lg={4} md={12} sx={{ width: '100%' }}>
                    <Box sx={(theme: Theme) => ({
                        padding: '25px 30px 45px 30px',
                        background: theme.palette.common.white,
                        borderRadius: '20px',
                        height: '100%',
                        width: '100%'
                    })}>
                        <CreditRatingLoader />
                    </Box>
                </Grid>

                <Grid item lg={8} md={12} sx={{ width: '100%' }}>
                    <Box sx={(theme: Theme) => ({
                        padding: '25px 30px 45px 30px',
                        background: theme.palette.common.white,
                        borderRadius: '20px',
                        height: '100%',
                    })}>
                        <BondsPerformanceLoader />
                    </Box>
                </Grid>

                <Grid item lg={12} md={12} sm={12} sx={{ width: '100%' }}>
                    <Box sx={(theme: Theme) => ({
                        padding: '25px 30px 45px 30px',
                        background: theme.palette.common.white,
                        borderRadius: '20px',
                        width: '100%',
                    })}>
                        <Top10BondHoldingsLoader />
                    </Box>
                </Grid>

                <Grid item lg={12} md={12} sm={12} sx={{ width: '100%' }}>
                    <Box sx={(theme: Theme) => ({
                        padding: '25px 30px 45px 30px',
                        background: theme.palette.common.white,
                        borderRadius: '20px',
                        width: '100%',
                    })}>
                        <BondsQuantativeAnalysisLoader />
                    </Box>
                </Grid>
            </Grid>
        </Box>
    )
}